import Vue from 'vue';
import { GlobalState } from '../../global-state/global-state';
import {
  setGTMcompareProductsEvent,
  setProductAbsorbencyDropRating,
  setProductCardBadge,
} from '../../utils/helpers';
import { nextArrow, prevArrow } from '../../utils/slick-theme-settings';
import ProductCardComponent from '../product-card/product-card';

const ProductShowcaseComponent = (showcaseElements) => {
  return new Vue({
    el: '#product-showcase-vue-filter',
    components: {
      'product-card': ProductCardComponent,
    },
    data: {
      showAddToCompareFeature: true,
      productCardsv1: {},
      productCards: [],
      sharedState: GlobalState.state,
      isSelectedv1: {},
      ctaButtonIsEnabled: true,
    },
    beforeMount() {
      // Set all products in compare list to true
      if (this.compareList.length) {
        this.compareList.forEach((item) =>
          this.$set(this.isSelected, item.id, true)
        );
        // Update the Compare List Index
        this.compareList.forEach(
          (item, index) => (item.compareListPosition = index)
        );
      }
    },
    methods: {
      renderDropletRating: function (tags) {
        return setProductAbsorbencyDropRating(tags);
      },
      renderProductBadge: function (data) {
        return setProductCardBadge(data);
      },
      ctaButtonClick: function (event) {
        // Need method to prevent VUE JS error.
      },
      addToCompareList: function (data) {
        if (this.compareList.length < 3) {
          const checkProductIsInArray = (product) =>
            product === data.productHandle;
          const compareListArray = GlobalState.getCompareList(this);
          let alreadyInArray = compareListArray.some(checkProductIsInArray);

          if (!alreadyInArray) {
            this.compareList.push({
              compareListPosition: this.compareList.length,
              id: data.id,
              handle: data.handle,
              title: data.title,
              imageSource: data.image,
            });

            // Set Global State
            GlobalState.setCompareList(this, this.compareList);

            // Set Google GTM Data Layer Veriable
            const gtmCompareProducts = GlobalState.getCompareList(this).map(
              (product) => product.title
            );
            setGTMcompareProductsEvent(
              gtmCompareProducts,
              'Homepage Recommendation'
            );
          }
        }
      },
      updateProductCards: function (products) {
        /**
         * Reactivity within Vue
         * Source - For Arrays: https://vuejs.org/v2/guide/reactivity.html#For-Arrays
         * Reset the Array - $set() Does Not Remove Entries...
         */

        this.productCards = [];

        /**
         * Using the $set since we are using a v-for to render
         */
        for (let index = 0; index < products.length; index++) {
          const element = products[index];
          this.$set(this.productCards, index, element);
        }

        /**
         * Update Liquid Slick Slider
         */
        if ($(showcaseElements.productCarouselDefaultSlider).length) {
          $(showcaseElements.productCarouselDefaultSlider)
            .on('destroy', function () {
              $(this).closest('.flex-container').remove();
              $(showcaseElements.productCarouselVueSlider).removeClass(
                'vue-slider-invisible'
              );
            })
            .slick('unslick');
        }
      },
    },
    filters: {
      money: function (value, sign = '$') {
        if (!value) return 0;
        return sign + value;
      },
      shopifyProductID: function (base64Id) {
        const decoded = atob(base64Id);
        const shopifyId = decoded.split('/').pop();
        return parseInt(shopifyId);
      },
    },
    computed: {
      compareList: function () {
        return this.sharedState.compareProductList;
      },
      isSelected: function () {
        return this.sharedState.selectedCompareProductIds;
      },
    },
    watch: {
      productCards: function () {
        // Destroy the Vue Slider
        $(showcaseElements.productCarouselVueSlider).slick('unslick');
        // Update Slide Slider
        this.$nextTick(function () {
          $(showcaseElements.productCarouselVueSlider)
            .on('init', () => {
              $(showcaseElements.productCarousel).fadeTo('fast', 1);
            })
            .slick({
              dots: false,
              prevArrow: prevArrow,
              nextArrow: nextArrow,
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            });
        });
      },
    },
  });
};

export default ProductShowcaseComponent;
